export default __webpack_public_path__ + "static/media/icon-verified-green.5b16cec6.svg";